import type { FC } from 'react';
import React from 'react';
import Select from 'react-select';

import { useField } from 'formik';

import { FieldFormGroupProps, FieldFormGroup } from '@shared/components/fields/field_form_group';

export type FormikAsyncSelectFormGroupOption = {
  value: string;
  label: string;
};

export const FormikReactSelectFormGroup: FC<
  FieldFormGroupProps & {
    name: string;
    loading?: boolean;
    options: Array<{
      label: string;
      value: string;
    }>;
  }
> = ({ id, help, label, name, options, loading }) => {
  const [{ value }, _, { setValue }] = useField(name);
  const selection = options.find((option) => option.value === value);
  return (
    <FieldFormGroup help={help} label={label} id={id}>
      <Select<FormikAsyncSelectFormGroupOption>
        isDisabled={loading}
        isClearable
        value={selection}
        onChange={(option) => {
          if (option) setValue(option.value);
          else setValue(undefined);
        }}
        options={options}
      />
    </FieldFormGroup>
  );
};
